"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CBOR = require("@wireapp/cbor");
var DecodeError_1 = require("../errors/DecodeError");
var Message = (function () {
    function Message() {
    }
    Message.prototype.serialise = function () {
        var encoder = new CBOR.Encoder();
        if (this instanceof CipherMessage_1.default) {
            encoder.u8(1);
        }
        else if (this instanceof PreKeyMessage_1.default) {
            encoder.u8(2);
        }
        else {
            throw new TypeError('Unexpected message type');
        }
        this.encode(encoder);
        return encoder.get_buffer();
    };
    Message.deserialise = function (buf) {
        var decoder = new CBOR.Decoder(buf);
        switch (decoder.u8()) {
            case 1:
                return CipherMessage_1.default.decode(decoder);
            case 2:
                return PreKeyMessage_1.default.decode(decoder);
            default:
                throw new DecodeError_1.default.InvalidType('Unrecognised message type', DecodeError_1.default.CODE.CASE_302);
        }
    };
    return Message;
}());
exports.default = Message;
var CipherMessage_1 = require("./CipherMessage");
var PreKeyMessage_1 = require("./PreKeyMessage");



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/message/Message.js
// module id = 29
// module chunks = 0 1